import React from 'react';
import Joyride, { EVENTS, STATUS } from 'react-joyride';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { markOnboardingComplete } from '../api/api';

const OnboardingTour = () => {
    const navigate = useNavigate();
    const { theme } = useTheme();

    const steps = [
        {
            target: 'body',
            content: 'Welcome to AlgoStock. Start with Today, explore the Scanner and build your trade plans.',
            placement: 'center'
        },
        { target: '#nav-today', content: 'Today is your decision screen: market context, themes, leaders and Stocks in Play.' },
        { target: '#nav-market-intelligence', content: 'Intelligence shows the evidence behind market, theme and leader rankings.' },
        { target: '#nav-plans', content: 'Plans freezes the setup, trigger, invalidation, stop and risk before execution.' },
        { target: '#nav-methodology', content: 'Trading Framework explains the process behind your research and trade plans.' },
        {
            target: 'body',
            content: 'Manage your account security from My Account and your subscription from Plan & Billing.',
            placement: 'center'
        },
    ];

    const handleJoyrideCallback = async (data) => {
        const { type, status, step } = data;

        if (type === EVENTS.STEP_AFTER) {
            if (step?.target === '#nav-today') navigate('/today');
            else if (step?.target === '#nav-market-intelligence') navigate('/market-intelligence');
            else if (step?.target === '#nav-plans') navigate('/trade-plans');
            else if (step?.target === '#nav-methodology') navigate('/methodology');
        }

        if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            try {
                await markOnboardingComplete();
                window.location.reload();
            } catch (error) {
                console.error("Failed to mark onboarding as complete", error);
            }
        }
    };

    return (
        <Joyride
            steps={steps}
            run={true}
            continuous={true}
            showProgress={true}
            showSkipButton={true}
            callback={handleJoyrideCallback}
            styles={{
                options: {
                    arrowColor: theme === 'dark' ? '#1a1a1c' : '#ffffff',
                    backgroundColor: theme === 'dark' ? '#1a1a1c' : '#ffffff',
                    overlayColor: 'rgba(0, 0, 0, 0.8)',
                    primaryColor: '#007BFF',
                    textColor: theme === 'dark' ? '#F0F1F2' : '#111827',
                    zIndex: 1000,
                }
            }}
        />
    );
};

export default OnboardingTour;
